module.exports = __webpack_public_path__ + "img/share_icon_mianduimian.f45a0af6.png";